import { render } from "./whatsapp-button.vue?vue&type=template&id=5e881ec8"
import script from "./whatsapp-button.vue?vue&type=script&lang=js"
export * from "./whatsapp-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__